export const translationES = {
  top: {
    text_1: 'Comida fresca y un planeta mejor',
    text_2: 'MILES',
    text_3: 'DE RECETAS',
    text_4: 'Un lugar que te ayuda a gestionar los ingredientes',
    text_5: 'Recetas de muchas cocinas',
    text_6: 'Menús semanales, lista de compras',
  },
  main_function: {
    text_1: 'Funciones principales',
    text_1_1: '¡Mantén tu comida fresca!',
    text_1_2: 'Recibe alertas de nuestro verificador de frescura para evitar desperdiciar comida',
    text_2_1: 'Sugerencias de recetas con IA',
    text_2_2: 'Descubre recetas de muchas cocinas del mundo según los ingredientes que tienes en tu refrigerador',
    text_3_1: 'Menús para toda la semana',
    text_3_2: 'Crea menús para toda la semana',
    text_4_1: 'Lista de compras',
    text_4_2: 'Crea y actualiza listas de compras para estar listo para tus compras',
    text_5: 'Descargar',
    text_6: 'iFridge te ayudará a',
    text_7_1: 'Convertirte en un mejor ama de casa',
    text_7_2: 'Reducir el desperdicio y hacer un planeta más saludable',
    text_7_3: 'Disfrutar cocinando',
  },
  rate_box: {
    text_1: 'Opiniones de los usuarios',
  },
  faqs: {
    text_1: 'Preguntas frecuentes',
    text_2_1: '¿Qué tipos de cuentas existen? ¿Puedo usar la aplicación gratis?',
    text_2_2: `Tienes el primer mes para usar todas las funciones de la aplicación de forma gratuita y sin anuncios.
      <br /><br />Después del primer mes, tu cuenta se convertirá automáticamente en una CUENTA GRATUITA.
      <br /><br />Con una CUENTA GRATUITA, puedes usar las funciones básicas de la aplicación como: ingredientes materiales, informe diario de estado de los ingredientes. No podrás usar algunas funciones avanzadas como: sugerencias de recetas con IA, menús semanales, lista de compras. También aparecerán anuncios al usar la aplicación.
      <br /><br />Para usar todas las funciones de la aplicación sin anuncios, necesitas actualizar a una CUENTA PREMIUM, con un costo mensual muy razonable.`,
    text_3_1: '¿Cuánto cuesta una CUENTA PREMIUM?',
    text_3_2: `Puedes suscribirte mensualmente o anualmente.
      <br /><br />Costo mensual: $0.99/mes.
      <br /><br />Costo anual: $9.99/año.
      <br /><br />No hay otros costos adicionales.`,
    text_4_1: '¿Puedo suscribirme a una CUENTA PREMIUM sin pagar?',
    text_4_2: `Absolutamente puedes.
      <br /><br />Para suscribirte a una CUENTA PREMIUM, puedes usar Puntos iFridge.
      <br /><br />Los Puntos iFridge se pueden comprar a través de App Store/Google Play: En la pantalla de configuración, toca el menú Puntos que te llevará a la pantalla de compra de puntos.
      <br /><br />O puedes ganar Puntos iFridge viendo anuncios: En la pantalla de configuración, toca el menú de otras configuraciones, toca Ver anuncios.`,
    text_5_1: '¿Recibo Puntos iFridge por ver anuncios?',
    text_5_2: `Puedes ganar Puntos iFridge viendo anuncios.
      <br /><br />Dependiendo de tu país, recibirás una cantidad determinada de Puntos iFridge por cada anuncio que veas (según las regulaciones de Google Admob). Después de ver un anuncio, necesitas esperar 20 minutos para poder ver el siguiente anuncio.`,
    text_6_1: '¿Puedo ganar Puntos iFridge al referir amigos?',
    text_6_2: `Absolutamente puedes obtener Puntos iFridge al referir amigos.
      <br /><br />Dependiendo de tu país, puedes obtener una cierta cantidad de Puntos iFridge al referir amigos compartiendo información sobre iFridge en redes sociales como Facebook, Twitter, etc.
      <br /><br />En un mes, solo puedes recibir Puntos iFridge una vez por referencias.`,
    text_7_1: '¿Mis datos personales están almacenados de forma segura? ¿Se comparten con terceros?',
    text_7_2:
      'Tus datos están completamente almacenados en tu teléfono y son completamente seguros. No almacenamos tus datos personales en nuestros servidores ni los compartimos con terceros.',
    text_8_1: 'Si necesito soporte, ¿cómo me contacto?',
    text_8_2: `Puedes contactarnos a través de la función Contáctanos: En la pantalla de configuración, selecciona Otras configuraciones, selecciona Contáctanos.
      <br /><br />O envía solicitudes de soporte/comentarios directamente al correo electrónico: ifridge.foodie@gmail.com`,
  },
  footer: {
    text_1: 'El amor puede ir y venir,',
    text_2: 'pero el hambre visita todos los días',
  },
};
